var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import * as ReactDOM from 'react-dom';
function parseValue(value) {
    if (value === '' || value === 'true') {
        return true;
    }
    if (value === 'false') {
        return false;
    }
    if (Number(value).toString() === value) {
        return Number(value);
    }
    return value;
}
function parseKey(key) {
    var parts = key.split('-');
    var newParts = [parts[0]];
    for (var i = 1; i < parts.length; i++) {
        var firstLetter = parts[i].slice(0, 1);
        var restOfLetters = parts[i].slice(1);
        var newPart = firstLetter.toUpperCase() + restOfLetters;
        newParts.push(newPart);
    }
    return newParts.join('');
}
function attrToObj(attrs) {
    var attrsObj = {};
    var length = attrs.length;
    for (var i = 0; i < length; i++) {
        var _a = attrs[i], name_1 = _a.name, value = _a.value;
        attrsObj[parseKey(name_1)] = parseValue(value);
    }
    return attrsObj;
}
function HtmlTagWrapper(Component) {
    var el = document.getElementById('kayna');
    var attrs = el.attributes;
    var props = attrToObj(attrs);
    ReactDOM.render(React.createElement(Component, __assign({}, props)), el);
}
export { HtmlTagWrapper };
